import ConvesationTopicType from "@/models/ConversationTopics/ConversationTopicType";

export default (value: ConvesationTopicType) => {
    switch (value) {
        case ConvesationTopicType.Central:
            return "Central";
        case ConvesationTopicType.Branch:
            return "Branch";
        case ConvesationTopicType.Desk:
            return "Desk";
        default:
            return "Unknown";
    }
} 